import CheckBox from './Checkbox';

export default CheckBox;



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/Checkbox/index.js